import type { UpsertOwnerInput } from '@sea-snag/shared';

/**
 * What the owner form sends. The email is optional (#216): left blank, the
 * owner is saved without one, and their status link is copied, not emailed.
 */
export function ownerFormPayload(form: {
  name: string;
  email: string;
  boatPids: string[];
}): UpsertOwnerInput {
  const email = form.email.trim();
  return { name: form.name.trim(), email: email === '' ? null : email, boatPids: form.boatPids };
}
